import * as React from "react";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import axios from "axios";
import Grid from "@mui/material/Grid";
import {
  Chip,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MyLocationsSmallCard from "./MyLocationsSmallCard";
import PreviewBox from "./PreviewBox";
import dayjs from "dayjs";
import { setpreviewLogout } from "../../redux/slices/Preview";
import { toast } from "react-toastify";
import { setCurrentEmms } from "../../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../../redux/slices/emmsAuthSlice";
import { setMeeting } from "../../redux/slices/meetingSlice";
import BanquetOptions from "./BanquetOptions";
import { setprivatelogout } from "../../redux/slices/Time";
import {
  setSelectedLayoutLogout,
  setSelectedLayoutPlaylistItemsLogout,
} from "../../redux/slices/selectedLayoutSlice";
import { clearTemplateValues } from "../../redux/slices/templateValuesSlice";
import { setScheduleLogout } from "../../redux/slices/scheduleSectionSlice";



export default function BulkMeetingCreation({ handleClose }) {
  const [open, setOpen] = useState(true);
  const headers = useSelector((state) => state?.header);
  const emmsheaders = useSelector((state) => state?.emmsheader);
  const curremms = useSelector((state) => state?.curremms);
  const selectedOption = curremms.curremms.id;
  const location = useSelector((state) => state?.location?.location);
  const preview = useSelector((state) => state?.preview);
  const [meetingSpaces, setMeetingSpaces] = useState([]);
  const [meetingObj, setMeetingObj] = useState(null);
  const api = localStorage.getItem("api");
  const [conflictingRooms, setConflictingRooms] = useState([]);
  const oldMeetingsData = useSelector((state) => state?.meeting?.meeting);
  const dispatch = useDispatch();
  const locationIds = useSelector((state) => state?.schedule?.locationIds);
  const roomIds = useSelector((state) => state?.schedule?.roomIds);
  const templateValues = useSelector((state) => state.templateValues);
  const contentAI = useSelector((state) => state.selectedContentAI);
  const selectedLayoutId = useSelector(
    (state) => state?.selectedLayout?.selectedLayout?.layoutId?.id
  );
  const user = useSelector((state) => state?.user.user);
  const fetchMeetingSpaces = async (meetingObject) => {
    const { startDate, endDate, startTime, endTime, roomIds } = meetingObject;
    const query = {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
      startTime,
      endTime,
      roomIds: roomIds?.join(","),
    };

    const requestBody = {
      path: "meetingspace/bulkfetch",
      query,
      emmsId: `${selectedOption}`,
      requestType: "GET",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    try {
      const response = await axios.post(
        `${api}/emms/piggyback`,
        requestBody,
        headers
      );

      toast.success("MR info fetched", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setMeetingSpaces(response.data?.meetingRooms || []);
      setConflictingRooms(response.data?.conflictingRooms || []);
    } catch (err) {
      toast.error("Error Fetching MR info", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      console.error("Error fetching meeting spaces:", err);
    }
  };

  useEffect(() => {
    const storedMeetingObj = JSON.parse(localStorage.getItem("meetingObject"));
    if (storedMeetingObj) {
      setMeetingObj(storedMeetingObj);
      fetchMeetingSpaces(storedMeetingObj);
    }
  }, []);
  const handleModalClose = () => {
    setOpen(false);
    dispatch(setSelectedLayoutLogout());
    dispatch(clearTemplateValues());
    dispatch(setSelectedLayoutPlaylistItemsLogout());
    dispatch(setpreviewLogout());
    dispatch(setScheduleLogout());
    dispatch(setSelectedLayoutLogout());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));
   
    const json = {
      ...meetingObject,
      locationIds,
      roomIds,
      customProperties: {
        ...meetingObject.customProperties,
        contentKey: {
          ...Object.keys(templateValues).reduce((acc, key) => {
            acc[`template_${key}`] = {
              arguments: {
                ...templateValues[key].arguments,
                event_name:
                  meetingObject.name ||
                  templateValues[key].arguments.event_name ||
                  "",
                host_name:
                  meetingObject.user ||
                  templateValues[key].arguments.host_name ||
                  "",
              },
              customProperties: templateValues[key].customProperties,
            };
            return acc;
          }, {}),
          contentAI: {
            ...contentAI,
          },
        },

        layoutId: selectedLayoutId,
        navigatorBooking: false,
        audit: {
          contentAiScheduleMaker: user.email,
        },
      },
    };

    localStorage.setItem("meetingObject", JSON.stringify(json));

    const requestBody = {
      path: "meeting/bulkcreate",
      query: {},
      body: { ...json },
      emmsId: `${selectedOption}`,
      requestType: "POST",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    return axios
      .post(`${api}/emms/piggyback`, requestBody, headers)
      .then((response) => {
        const combinedData = [...response?.data, ...oldMeetingsData];

        dispatch(setMeeting(combinedData));
        toast.success("Created successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        return response.data;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error Creating Schedule", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        throw new Error(error.response?.data?.message || error.message);
      })
      .finally(() => {
        dispatch(setpreviewLogout());
        localStorage.setItem("meetingObject", JSON.stringify({}));
        handleModalClose();
        handleClose(); 
      });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          width: "100vw",
          height: {xs:"100%", md:"100vh"},
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.paper",
          padding: 2,
        }}>
          <Box
            sx={{
              padding: 2,
              height: { xs: "8vh", md: "10vh" },
              width: "100%",
              borderBottom: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              color="primary"
              variant="h5"
              sx={{
                display: {
                  xs: "none",
                  md: "block"
                }
              }}
            >
              Elhi Landscape Manager
            </Typography>
            <TextField
              label="Schedule/Event Name"
              variant="standard"
              placeholder="Playlist"
              sx={{ mb: 2 }}
              disabled
              value={meetingObj?.name || ""}
              InputLabelProps={{
                sx: {
                  maxWidth: {
                    xs: "80%",
                    md: "100%",
                  },
                },
              }}
              InputProps={{
                endAdornment: <IconButton>{<EditIcon />}</IconButton>,
              }}
            />
            <TextField
              label="Host Name"
              variant="standard"
              placeholder="HostName"
              sx={{ mb: 2 }}
              disabled
              value={meetingObj?.user || ""}
              InputLabelProps={{
                sx: {
                  maxWidth: {
                    xs: "80%",
                    md: "100%",
                  },
                },
              }}
              InputProps={{
                endAdornment: <IconButton>{<EditIcon />}</IconButton>,
              }}
            />
          </Box>

          <Box
            sx={{
              height: "50vh",
              flex: 1,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <Box
              sx={{
                flex: 4,
                display: "flex",
                flexDirection: "column",

                gap: 2,
              }}
            >
              <Box
                sx={{
                  padding: { xs: 1, md: 1.5 },
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 1, md: 2 } }}>
                  <Chip
                    label="Schedule Date & Time"
                    sx={{
                      fontSize: ".8rem",
                      padding: "4px 12px",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
                <Box>
                  <Box sx={{ display: "flex", gap: 1, mb: { xs: 1, md: 3 } }}>
                    <TextField
                      value={
                        meetingObj?.startDate
                          ? dayjs(meetingObj?.startDate).format("YYYY-MM-DD")
                          : ""
                      }
                      sx={(theme) => ({
                        "& .MuiInputBase-input": {
                          [theme.breakpoints.down("md")]: {
                            padding: "8.5px 14px",
                          },
                        },
                      })}
                      variant="outlined"
                      disabled
                    />
                    <TextField
                      value={
                        meetingObj?.endDate
                          ? dayjs(meetingObj?.endDate).format("YYYY-MM-DD")
                          : ""
                      }
                      sx={(theme) => ({
                        "& .MuiInputBase-input": {
                          [theme.breakpoints.down("md")]: {
                            padding: "8.5px 14px",
                          },
                        },
                      })}
                      variant="outlined"
                      disabled
                    />
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      value={
                        meetingObj?.startTime
                          ? dayjs(meetingObj?.startTime).format("HH:mm")
                          : ""
                      }
                      sx={(theme) => ({
                        "& .MuiInputBase-input": {
                          [theme.breakpoints.down("md")]: {
                            padding: "8.5px 14px",
                          },
                        },
                      })}
                      variant="outlined"
                      disabled
                    />
                    <TextField
                      value={
                        meetingObj?.endTime
                          ? dayjs(meetingObj?.endTime).format("HH:mm")
                          : ""
                      }
                      sx={(theme) => ({
                        "& .MuiInputBase-input": {
                          [theme.breakpoints.down("md")]: {
                            padding: "8.5px 14px",
                          },
                        },
                      })}
                      variant="outlined"
                      disabled
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                  mb: { xs: 1, md: 2 },
                  mt: { xs: 1, md: 1.5 },
                }}
              >
                <Chip
                  label="Banquet Options"
                  sx={{
                    fontSize: ".8rem",
                    padding: "4px 12px",
                    borderRadius: "8px",
                  }}
                />
              </Box>
              <BanquetOptions />
            </Box>
          </Box>
          <Box
            sx={{
              padding: 2,
              px: { xs: 0, md: 2 },
              borderRadius: 2,
              height: "100%",
              overflowY: "hidden",
            }}
          >
         
            <MyLocationsSmallCard
              locations={location}
              actions={true}
              conflictingRooms={conflictingRooms}
              setConflictingRooms={setConflictingRooms}
              isConflict={true}
            />
          </Box>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem",
              marginRight: "1em",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleModalClose}
              color="error"
              style={{ textTransform: "none" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              style={{ textTransform: "none" }}
            >
              Create
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
